// @ts-check
// Rotas do público das campanhas e dos fluxos (contrato 09 de público, seção 8): prévia ao vivo, cards do "Ver todos" e
// uso de views. No modo demonstração, o mock do público responde (client/src/data/mock-audiences.js).
import { api } from './api-client.js';

/**
 * @typedef {import('../../../shared/audiences/audience-definition.js').AudienceDefinition} AudienceDefinition
 * @typedef {{ status: 'ELIGIBLE' | 'EXCLUDED', address: string | null, reason: string | null }} AudienceOutcome
 * @typedef {{ personId: string | null, displayName: string, recipientRole: string, outcomes: Record<string, AudienceOutcome> }} AudienceSampleRecipient
 * @typedef {{ cardId: string, cardName: string, stage: string | null, createdAt: string, recipients: AudienceSampleRecipient[] }} AudienceSampleCard
 * @typedef {{ channel: 'EMAIL' | 'WHATSAPP', purpose: 'MARKETING' | 'SERVICE', isEstimate: boolean, basedOnCards: number, eligible: number,
 *   duplicates: number, excluded: Record<string, number>, serviceWithoutRelationship?: number }} AudienceChannelCount
 * @typedef {{ computedAt: string, cards: { total: number, byStage: Array<{ stage: string, count: number }>, byCreatedBySource?: Record<string, number> },
 *   recipients: AudienceChannelCount[], sample: AudienceSampleCard[], restFilter: string | null, ignoredFilterIds: string[],
 *   problems: Array<{ filterId: string | null, code: string }>, warnings: Array<{ code: string, [key: string]: unknown }> }} AudiencePreview
 * @typedef {{ id: string, name: string, stage: string | null, createdAt: string, pointOfContactId: string | null, pointOfContactName: string | null }} AudienceCard
 */

/**
 * @param {{ definition: AudienceDefinition, usage?: 'AUDIENCE' | 'CONDITION', channels?: Array<'EMAIL' | 'WHATSAPP'>,
 *   purpose?: 'MARKETING' | 'SERVICE', sampleSize?: number }} input
 * @returns {Promise<AudiencePreview>}
 */
export async function previewAudience(input) {
  const body = await api.post('/rest/audiences/preview', input);
  return body.data;
}

/**
 * Página do "Ver todos": do card mais novo, 50 por vez.
 * @param {{ definition: AudienceDefinition, usage?: 'AUDIENCE' | 'CONDITION', cursor?: string | null, limit?: number }} input
 * @returns {Promise<{ total: number | null, cards: AudienceCard[], nextCursor: string | null }>}
 */
export async function fetchAudienceCards(input) {
  const body = await api.post('/rest/audiences/cards', input);
  return body.data;
}

/**
 * Campanhas e fluxos que usam a view (aviso antes de mudar os filtros de uma view da escola).
 * @param {string} viewId
 * @returns {Promise<{ total: number, live: number, byKind: Record<string, number>, items: Array<{ kind: string, id: string, name: string, isLive: boolean }> }>}
 */
export async function fetchViewAudienceUsages(viewId) {
  const body = await api.get(`/rest/audiences/view-usages/${encodeURIComponent(viewId)}`);
  return body.data;
}
